// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  FIREBASE_CREDENTIAL: {
    apiKey: 'AIzaSyCc48hm5GSDkOuuEhRu3KA_oZ5qPisKIbQ',
    authDomain: 'supervisor-dev-7ed37.firebaseapp.com',
    projectId: 'supervisor-dev-7ed37',
    storageBucket: 'supervisor-dev-7ed37.appspot.com',
    messagingSenderId: '551686668884',
    appId: '1:551686668884:web:3a03a05bbed3b2c237e3c1',
    measurementId: 'G-P7WYHF9MBM',
  },
  NS_URL: 'https://api-test.colleen.ai/sv',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
